<li class="pageFeatureContainer">
    <b *ngIf="title !== ''" >{{title}}</b>&nbsp;
    <span *ngIf="description !==''">{{description}}</span>
</li>
